import { motion } from "framer-motion";
import { Youtube, Music2, Video } from "lucide-react";

const socials = [
  {
    name: "YouTube",
    url: "https://www.youtube.com/channel/UCPfExabhhHUtXF30EZBHAzA",
    icon: Youtube,
  },
  {
    name: "Spotify",
    url: "https://open.spotify.com/artist/2qEWBu2U2c5bzsnSrfpBY4?si=nJlIjUvfRzmUK6y4G4Aq3g",
    icon: Music2,
  },
  {
    name: "TikTok",
    url: "https://www.tiktok.com/@puebloptkwo",
    icon: Video,
  },
];

export default function Socials() {
  return (
    <footer
      id="socials"
      data-testid="socials-section"
      className="relative py-24 md:py-32 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="font-['Oswald'] text-3xl md:text-4xl font-bold uppercase tracking-tighter mb-2">
            Obserwuj
          </h2>
          <div className="w-16 h-[2px] bg-[#EB0023] mx-auto mb-10" />
        </motion.div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16">
          {socials.map((social, idx) => (
            <motion.a
              key={social.name}
              data-testid={`social-link-${social.name.toLowerCase()}`}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: idx * 0.1 }}
              className="group flex items-center gap-4 text-[#A0B0C4] hover:text-white transition-colors"
              whileHover={{ x: 4 }}
            >
              <social.icon className="w-6 h-6 group-hover:text-[#EB0023] transition-colors" />
              <span className="font-['Oswald'] text-2xl md:text-3xl uppercase tracking-wider">
                {social.name}
              </span>
            </motion.a>
          ))}
        </div>

        {/* Large background text */}
        <div className="mt-20 text-center select-none pointer-events-none">
          <span className="font-['Oswald'] text-[8rem] md:text-[14rem] lg:text-[18rem] font-bold uppercase tracking-tighter leading-none text-[#192D48]/15">
            PUEBLO
          </span>
        </div>

        <div className="text-center mt-8">
          <p className="font-['Manrope'] text-xs text-[#32558B]">
            &copy; 2025 Pueblo. Wszystkie prawa zastrzeżone.
          </p>
          <p className="font-['Manrope'] text-xs text-[#32558B] mt-2">
            Strona stworzona przez{" "}
            <a
              href="https://stormly-webdesign.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#A0B0C4] hover:text-white transition-colors"
              data-testid="stormly-credit-link"
            >
              Stormly Web Design
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
